import { useEffect } from 'react';
import { LoadConfig } from 'utils/loadConfig';

export const LivechatLoader = () => {
  useEffect(() => {
    const cfg = LoadConfig();
    const base = cfg.REACT_APP_LIVECHAT_BASE;
    const channel = cfg.REACT_APP_LIVECHAT_CHANNEL;
    const language = cfg.REACT_APP_LIVECHAT_LANG;
    const pollingMs = Number(cfg.REACT_APP_LIVECHAT_POLLING_MS ?? 5500);

    (window as any).IturanConfig = (window as any).IturanConfig || {};
    (window as any).IturanConfig.apiGatewayUrl = `${base}/communication/livechat/`;
    (window as any).IturanConfig.channelIdentifier = channel;
    (window as any).IturanConfig.language = language;
    (window as any).IturanConfig.pollingInterval = pollingMs;

    const script = document.createElement('script');
    script.src = `${base}/livechat/ituran-widget.bundle.js`;
    script.setAttribute('data-ituran-loader', '1');
    script.async = true;
    document.body.appendChild(script);

    return () => {
      try {
        document.body.removeChild(script);
      } catch {}
    };
  }, []);

  return null;
};

export default LivechatLoader;


